import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppFilter } from '@app/shared/models';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  OrganizationService,
  PdfViewerService,
} from 'src/modules/features/admin/services';
import { DocumentTypeService } from 'src/modules/features/setting/services';
import { CompanyService, DashboardProvider } from '../../services';
import { AolService } from '../../services/aol';
import { Location } from '@angular/common';

interface IViewHistoryModalContext {
  title: string;
  toEdit: string;
  data?: any;
  organizationId?: string;
  directId?: string;
}
@Component({
  selector: 'app-view-history-modal',
  templateUrl: './view-history-modal.component.html',
  styleUrls: ['./view-history-modal.component.scss'],
})
export class ViewHistoryModalComponent implements OnInit {
  toEdit = this.modal.context.toEdit;
  allPendingHistory;
  pendingHistory;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 2;
  organizationId: string;
  allHistory: any = [];
  groupedDocuments: any = [];
  isPending: boolean = this.modal.context.data
    ? this.modal.context.data.isPending
    : false;
  isChecked: string;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'changeRequestType',
        op: 'cn',
        data: this.toEdit,
      },
    ],
  };
  collapseHistory = [];
  selectedRequest: any;
  detail: any;
  documents;
  states;
  origin;
  nationality;
  countries;
  documentsType;
  allAffiliateTypeNames = [];
  pendingArr: boolean[] = [];
  allStatus: any;
  documentData;
  personnelStructures: any[] = [];
  baseUrl = environment.API_SERVER;
  affiliateTypeId;
  companyOrganization;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private companySvc: CompanyService,
    private organizationSvc: OrganizationService,
    private documentTypeSvc: DocumentTypeService,
    public modal: SuiModal<IViewHistoryModalContext, void, void>,
    private companyOwnershipService: CompanyOwnershipService,
    private dashboardSvc: DashboardProvider,
    private AolService: AolService,
    private activatedRoute: ActivatedRoute,
    private pdfViewerService: PdfViewerService,
    private location: Location
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.affiliateTypeId = params.typeId;
    });
    this.toEdit = modal.context.toEdit;
    if (this.modal.context.organizationId) {
      this.organizationId = this.modal.context.organizationId;
    } else {
      this.organizationId = window.localStorage.getItem('organizationId');
    }

    // this.filter.filters = JSON.stringify(this.searchFilter);
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    if (this.modal.context.directId) {
      this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    }
    this.getPage(1);
    this.getAllAffiliateTypeNames();
    this.getCountry();
    this.getStates();
    this.getOptionTypes();
  }
  viewDocument(data) {
    this.pdfViewerService.viewPdf(data);
  }
  ngOnInit(): void {}
  fromValue;
  shareholder = [];
  submit(id?) {
    console.log(id);
    this.pending = true;
    let searchFilter2 = {
      groupOp: 'AND',
      rules: [
        {
          field: 'changeRequestId',
          op: 'eq',
          data: id ? id : this.isChecked,
        },
      ],
    };
    this.filter.filters = JSON.stringify(searchFilter2);
    this.companySvc
      .getRequestHistory({
        organizationId: this.organizationId,
        changeRequestType: this.toEdit,
        params: this.filter,
      })
      .pipe(
        tap((res) => {
          this.totalItems = +res['records'];
          this.currentPage = 1;
          this.rows = this.filter.rows;
        })
      )
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.selectedRequest = res.rows[0];
          console.log(this.selectedRequest, 'selectedRequest');
          this.companyOrganization =
            this.selectedRequest.organization.jpaContractor;
          this.detail = JSON.parse(this.selectedRequest.toValue);
          this.fromValue = JSON.parse(this.selectedRequest.fromValue);
          console.log(this.fromValue, this.detail, 'this.personnelStructures');

          if (
            this.personnelStructures.includes(
              this.selectedRequest.changeRequestType
            )
          ) {
            console.log('ithithere');
            const seenOrganizationOwnershipIds = new Set();
            if (this.fromValue.length > 0) {
              this.fromValue = this.fromValue.filter((item) => {
                if (
                  !seenOrganizationOwnershipIds.has(
                    item.organizationOwnershipId
                  )
                ) {
                  seenOrganizationOwnershipIds.add(
                    item.organizationOwnershipId
                  );
                  return true;
                }
                return false;
              });
            }

            console.log(this.fromValue, 'second');
            console.log('initial');
            this.detail.map((item) => {
              this.shareholder.push(item);
            });
            this.fromValue.map((item) => {
              if (item.actionType) {
              } else {
                // this.shareholder.push(item);
              }
            });
            this.detail.map((item) => {
              if (item.actionType === 'NONE') {
                this.fromValue.push(item);
              } else if (item.actionType) {
              } else {
                this.fromValue.push(item);
              }
            });
            const seenNationalIds = new Set();
            if (this.fromValue.length > 0) {
              this.fromValue = this.fromValue.filter((item) => {
                if (!seenNationalIds.has(item.nationalIdNumber)) {
                  seenNationalIds.add(item.nationalIdNumber);
                  return true;
                }
                return false;
              });
            }

            let seen = new Set();
            this.shareholder = this.shareholder.filter((obj) => {
              if (obj.actionType === 'ADD') {
                return true;
              } else if (seen.has(obj.organizationOwnershipId)) {
                return false;
              } else {
                seen.add(obj.organizationOwnershipId);
                return true;
              }
            });
            console.log(this.fromValue, 'fromValue');
            console.log(this.detail, 'toValue');
            console.log(this.shareholder, 'shareholder');
          }
          if (
            this.selectedRequest.status === 'VERIFIED' &&
            this.personnelStructures.includes(
              this.selectedRequest.changeRequestType
            )
          ) {
            const seenOrganizationOwnershipIds = new Set();
            if (this.fromValue.length > 0) {
              this.fromValue = this.fromValue.filter((item) => {
                if (
                  !seenOrganizationOwnershipIds.has(
                    item.organizationOwnershipId
                  )
                ) {
                  seenOrganizationOwnershipIds.add(
                    item.organizationOwnershipId
                  );
                  return true;
                }
                return false;
              });
            }

            console.log(this.fromValue, 'second');
            this.detail = this.detail.filter((item) => {
              return item.actionType !== 'DELETE';
            });
            this.shareholder = this.shareholder.filter((item) => {
              return item.actionType !== 'DELETE';
            });
            if (this.fromValue.length > 0) {
              this.fromValue = this.fromValue.filter((item) => {
                if (item.actionType === 'ADD') {
                } else {
                  return item;
                }
              });
            }
          }
          console.log(this.pending, 'data');

          this.personnelStructures.includes(
            this.selectedRequest.changeRequestType
          )
            ? (this.documents = this.detail[0]?.documents)
            : (this.documents = this.detail?.documents);
          console.log(this.documents, 'detailshere');
          if (this.selectedRequest.changeRequestType === 'TIN') {
            console.log('enterhere');
            this.documents = [this.detail?.document];
            console.log(this.documents, this.detail?.document);
          }
          const cleanedArray = this.documents?.filter(
            (item) => item !== undefined
          );
          if (cleanedArray && cleanedArray > 0) {
            console.log(this.documents, 'nahere');
            this.groupData(this.documents);
            this.isPending = true;
            setTimeout(() => {
              this.pending = false;
              console.log(this.pending, 'data');
            }, 2000);
          } else {
            this.getDocuments();
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  goBackToList() {
    if (this.modal.context.directId) {
      this.modal.deny(undefined);
    } else {
      if (this.allHistory) {
        this.isPending = false;
        this.isChecked = null;
      }
    }
  }

  getStatus(status) {
    if (status === 'PENDING') {
      return;
    }
    if (status === 'ACCEPTED') {
    }
    if (status === 'REJECTED') {
    }
    if (status === 'ACCEPTED') {
    }
  }
  groupData(data) {
    console.log(data, 'here');
    data.map((item) => {
      if (item.documentTypeId && !item.documentTypeId.documentTypeName) {
        item.documentTypeId.documentTypeName = item.documentName;
      }
    });
    const groupedObjects = data.reduce((result, obj) => {
      const key =
        obj.documentTypeId && obj.documentTypeId.documentTypeId
          ? obj.documentTypeId.documentTypeName
          : obj.documentTypeName;
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(obj);
      return result;
    }, {});
    this.groupedDocuments = Object.entries(groupedObjects).map(
      ([key, value]) => ({ key, value })
    );
    console.log(this.groupedDocuments, 'documents');
  }
  getDocumentPath(data) {
    this.pending = true;
    this.AolService.getDocument({ documentId: data }).subscribe(
      (res: any) => {
        this.pending = false;
        return `${this.baseUrl}/public/image/?media=${res.documentPath}`;
        // this.documentData = `${this.baseUrl}/public/image/?media=${res.documentPath}`;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }
  getOptionTypes() {
    let filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10000,
      sord: 'desc',
    });
    this.documentTypeSvc.getDocumentType({ params: filter }).subscribe(
      (res: any) => {
        // this.optionLoading = false;
        this.documentsType = res['rows'];
      },
      (error) => {}
    );
  }
  filterDocumentType(data) {
    let result = this.documentsType.filter((item) => {
      return item.documentTypeId === data;
    });
    return result[0].documentTypeName;
  }
  getCountry() {
    this.organizationSvc
      .getCountries({ organizationId: this.organizationId })
      .subscribe((res) => {
        this.countries = res['rows'];
      });
  }
  filterCountry(data) {
    let result = this.countries.filter((item) => {
      return item.countryCode === data;
    });
    return result[0]?.countryName;
  }
  filterStates(data) {
    let result = this.states.filter((item) => {
      return item.stateId === data;
    });
    return result[0]?.stateName;
  }
  getCountryOrigin(data) {
    this.organizationSvc
      .getCountries({ organizationId: this.organizationId })
      .subscribe((res) => {
        this.origin = res['rows'];
        this.origin = this.origin.filter((item) => {
          return item.countryCode === data.countryOfOriginId;
        });
        this.origin = this.origin[0];
      });
  }

  getCountryNational(data) {
    this.organizationSvc
      .getCountries({ organizationId: this.organizationId })
      .subscribe((res) => {
        this.nationality = res['rows'];
        this.nationality = this.nationality.filter((item) => {
          return item.countryCode === data.nationalityId;
        });
        this.nationality = this.nationality[0];
      });
  }
  getStates() {
    this.organizationSvc.getStates({ filter: '' }).subscribe((res) => {
      this.states = res['rows'];
      // this.states = this.states.filter((item) => {
      //   return item.stateId === data.headOfficeAddressState;
      // });
      // this.states = this.states[0];
    });
  }
  getDocuments() {
    this.pending = true;
    this.companySvc
      .getRequestDocument({
        changeRequestType: this.selectedRequest.changeRequestId,
      })
      .subscribe(
        (res) => {
          this.documents = res;
          this.groupData(this.documents);
          this.isPending = true;
          setTimeout(() => {
            this.pending = false;
            console.log(this.pending, 'data');
          }, 2000);
        },
        (error) => {
          this.isPending = true;
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  toggleHistory(i) {
    this.collapseHistory[i] = !this.collapseHistory;
    this.collapseHistory[i] == false;
  }

  getPage(page) {
    this.pending = true;
    this.companySvc
      .getRequestHistory({
        organizationId: this.organizationId,
        changeRequestType: this.toEdit,
        params: this.filter,
      })
      .pipe(
        tap((res) => {
          this.totalItems = +res['records'];
          this.currentPage = page;
          this.rows = this.filter.rows;
        })
      )
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.allHistory = res['rows'];
          console.log(this.allHistory, 'allhistory');
          this.getVerificationStatus();
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  nextPage(value) {
    this.filter.page = value;
    this.getPage(this.filter.page);
  }
  getPendingHistory() {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'organizationId',
          op: 'cn',
          data: this.organizationId,
        },
      ],
    };

    this.filter.filters = JSON.stringify(searchFilter);
    this.pending = true;
    this.companySvc
      .getPendingHistory({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.allPendingHistory = res['rows'];
          console.log('pending history ', res);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getAllAffiliateTypeNames() {
    this.pendingArr.push(true);
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypeNames = res.map((elem) =>
          elem.optionName.toUpperCase()
        );
        this.getPersonnelStructureTypes();
        this.pendingArr.pop();
      },
      (err: any) => {
        this.pendingArr.pop();
        console.log(err);
      }
    );
  }
  returnJson(data) {
    return JSON.parse(data);
  }

  goBack() {
    this.location.back();
  }
  getVerificationStatus() {
    this.pendingArr.push(true);
    this.dashboardSvc
      .getStatus({
        organizationId: this.organizationId,
      })
      .subscribe(
        (res) => {
          this.pendingArr.pop();
          this.allStatus = res;
          this.getAllAffiliateTypeNames();
        },
        (error) => {
          this.pendingArr.pop();
          // this.error = error.error.errorMessage ? error.error.errorMessage
          //                                       : error.error ? error.error
          //                                       : error;
        }
      );
  }

  getPersonnelStructureTypes() {
    let t = setTimeout(() => {
      if (this.allStatus && this.allAffiliateTypeNames.length) {
        clearTimeout(t);
        let statusKeys = Object.keys(this.allStatus);
        statusKeys = statusKeys.map((key) => key.toUpperCase());
        this.allAffiliateTypeNames.forEach((affiliateType) => {
          statusKeys.every((key) => {
            if (key.includes(affiliateType)) {
              this.personnelStructures.push(key);
              return false;
            }
            return true;
          });
        });
        if (this.modal.context.directId) {
          this.submit(this.modal.context.directId);
        }
      }
    }, 100);
  }
}

export class ViewHistoryModal extends ComponentModalConfig<
  IViewHistoryModalContext,
  void,
  void
> {
  constructor(
    title: string,
    toEdit: string,
    data?: any,
    organizationId?: string,
    directId?: string,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(ViewHistoryModalComponent, {
      title,
      toEdit,
      data,
      organizationId,
      directId,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
